// Builds the localStorage keys used to pass the O365/Excel FILE_ID from the
// SpreadSheetInteraction component into ItemResultSerializer. Keys are scoped
// per question (contentRevisionId) so that concurrent or revisited spreadsheet
// questions in the same test don't overwrite/consume each other's file id.
function getSpreadSheetFileIdStorageKey(contentRevisionId) {
    return {
        isSpreadSheetQuestionKey: `isSpreadSheetQuestion_${contentRevisionId}`,
        studentFileIdKey: `studentFileId_${contentRevisionId}`,
    };
}

export default getSpreadSheetFileIdStorageKey;
